import "bootstrap/dist/css/bootstrap.min.css";
import { get, ref } from "firebase/database";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { db } from "../Firebase";

const Login = () => {
  const [form, setForm] = useState({ userId: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(p => ({ ...p, [name]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!form.userId || !form.password) {
      alert("कृपया User ID और Password दर्ज करें");
      return;
    }

    setLoading(true);
    
    try {
      const usersRef = ref(db, "passwords");
      const snapshot = await get(usersRef);
      
      if (!snapshot.exists()) {
        alert("कोई उपयोगकर्ता नहीं मिला");
        return;
      }

      const users = snapshot.val();
      const user = Object.values(users).find(
        u => (u.email === form.userId || u.phone === form.userId) && u.password === form.password
      );

      if (!user) {
        alert("गलत User ID या Password");
        return;
      }

      // Store user session
      sessionStorage.setItem('user', JSON.stringify({
        name: user.name,
        email: user.email,
        role: user.role
      }));

      // Navigate based on role
      if (user.role === 'Admin') {
        navigate('/admin');
      } else if (user.role === 'Employee') {
        navigate('/employee');
      } else {
        navigate('/dashboard');
      }
      
    } catch (error) {
      console.error('Login error:', error);
      alert("लॉगिन में त्रुटि हुई");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #F3F4F6, #E5E7EB, #D1D5DB)",
      }}
    >
      <div
        className="card shadow-lg p-4"
        style={{
          width: "380px",
          borderRadius: "16px",
          border: "1px solid #213F6D",
        }}
      >
        {/* Logo */}
        <div className="text-center mb-3">
          <img src="/Logo.png" alt="Logo" height="80"/>
        </div>

        {/* Heading */}
        <h4
          className="text-center mb-4 fw-bold"
          style={{ color: "#213F6D" }}
        >
          User Login
        </h4>

        <form onSubmit={handleLogin}>
          {/* User ID */}
          <div className="mb-3">
            <label className="form-label fw-semibold">User ID</label>
            <input
              type="text"
              name="userId"
              className="form-control"
              placeholder="Enter email or phone"
              value={form.userId}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          {/* Password */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Password</label>
            <input
              type="password"
              name="password"
              className="form-control"
              placeholder="Enter your password"
              value={form.password}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          {/* Login Button */}
          <button
            type="submit"
            className="btn w-100 fw-semibold mb-2"
            style={{
              backgroundColor: "#4A6FA5",
              color: "#fff",
            }}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {/* Forgot Password */}
        <div className="text-center">
          <Link
            to="/forgot-password"
            style={{
              textDecoration: "none",
              color: "#213F6D",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            Forgot Password?
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
